/* <soh-add-to-cart> wraps a <button>. Reads the selected option from the nearest <soh-purchase-options>
   (or data-variant-id / data-selling-plan-id on itself; data-ignore-options = fixed one-time add, e.g. the 'buy once' link), POSTs /cart/add.js, opens the drawer.
   States: .is-loading, [data-atc-error] message, sold out when data-available="false". */
class SohAddToCart extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('button');
    this.error = this.querySelector('[data-atc-error]');
    if (this.dataset.available === 'false') { this.button.disabled = true; this.button.textContent = this.dataset.soldOutLabel || 'Sold out'; return; }
    this.button.addEventListener('click', () => this.add());
    /* ?option=once: the main button adds the selected quantity as a one-time purchase (no selling plan). */
    if (window.SOH && SOH.funnel.option === 'once' && this.hasAttribute('data-main')) { this.once = true; document.documentElement.dataset.option = 'once'; }
    if (window.SOH && SOH.funnel.add && this.hasAttribute('data-main')) {
      SOH.funnel.add = false; /* only once */
      requestAnimationFrame(() => this.add());
    }
  }
  selection() {
    if (this.hasAttribute('data-ignore-options')) return { id: this.dataset.variantId, quantity: Number(this.dataset.quantity || 1), selling_plan: undefined };
    const po = document.querySelector(this.dataset.optionsFor || 'soh-purchase-options');
    const id = (po && po.dataset.variantId) || this.dataset.variantId;
    if (this.once) return { id, selling_plan: undefined };
    return { id, selling_plan: (po && po.dataset.sellingPlanId) || this.dataset.sellingPlanId || undefined };
  }
  async add() {
    const sel = this.selection(); if (!sel.id) return;
    this.button.classList.add('is-loading'); this.button.setAttribute('aria-busy', 'true');
    if (this.error) this.error.hidden = true;
    try {
      const res = await SOH.cart.add({ id: sel.id, quantity: sel.quantity || 1, selling_plan: sel.selling_plan });
      SOH.renderSections(res.sections);
      this.button.classList.add('is-success'); setTimeout(() => this.button.classList.remove('is-success'), 1500);
      SOH.emit('soh:cart:updated', { source: 'atc' }); SOH.emit('soh:cart:open');
    } catch (e) {
      if (this.error) { this.error.textContent = e.message || 'Something went wrong. Please try again.'; this.error.hidden = false; }
    } finally { this.button.classList.remove('is-loading'); this.button.removeAttribute('aria-busy'); }
  }
}
customElements.define('soh-add-to-cart', SohAddToCart);
